import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "./common";
import { Secret } from "../../schema/types/secret/entity";

export const secretApi = createApi({
  reducerPath: "secretApi",
  baseQuery: customBaseQuery,
  tagTypes: ["Secret"],
  endpoints: (builder) => ({
    getSecret: builder.query<Secret, string>({
      queryFn: async (link) => {
        try {
          const { request } = await import("../../services/cpln");
          const { data } = await request({ url: link });
          return { data };
        } catch (error: any) {
          return {
            error: {
              status: error.response?.status || 500,
              data: error.response?.data || error.message,
            },
          };
        }
      },
      providesTags: (result, error, link) => [{ type: "Secret", id: link }],
    }),
    revealSecret: builder.query<Secret, string>({
      queryFn: async (link) => {
        try {
          const { request } = await import("../../services/cpln");
          const { data } = await request({ url: `${link}/-reveal` });
          return { data };
        } catch (error: any) {
          return {
            error: {
              status: error.response?.status || 500,
              data: error.response?.data || error.message,
            },
          };
        }
      },
      providesTags: (result, error, link) => [{ type: "Secret", id: `${link}/-reveal` }],
    }),
  }),
});

export const { useGetSecretQuery, useLazyRevealSecretQuery } = secretApi;
